"use client"
import InputBase from "@mui/material/InputBase"
import SearchIcon from "@mui/icons-material/Search"
import { styled, alpha } from "@mui/material/styles"
import Button from "@mui/material/Button"
import Filter from "./Filter"

const Search = styled("div")(({ theme }) => ({
  background: "black",
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}))

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}))

const SearhcBar = ({ filterState, setFilterState, callFunction, userType }) => {
  const handleSearch = (text) => {
    setFilterState({ ...filterState, query: text })
  }

  return (
    <>
      <Header>
        <div>
          <Search>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                callFunction(1)
              }}
            >
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                id="searchInput"
                placeholder="Search…"
                inputProps={{ "aria-label": "search", maxLength: 30 }}
                onChange={(e) => {
                  handleSearch(e.target.value)
                }}
              />
            </form>
          </Search>
          <Button
            type="button"
            variant="contained"
            size="small"
            onClick={() => {
              callFunction(1)
            }}
          >
            Search
          </Button>
        </div>
        <Filter
          filterState={filterState}
          setFilterState={setFilterState}
          callFunction={callFunction}
          userType={userType}
        />
      </Header>
    </>
  )
}

const Header = styled("div")`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &>div{
        display: flex;
        align-items: center;
        border: 1px solid var(--card-border);
        border-radius: 8px;
    }
    button{
        margin: 0 1rem;
        height: 18px;
        font-size: 70%;
        text-decoration: none !important;
        background-color: var(--nona-light-blue);
    }
`

export default SearhcBar